import { httpRequest } from '@/apis/request'

enum Apis {
  banner = 'banners',
}

export async function getBanner(params: any) {
  return httpRequest.get(Apis.banner, params)
}
